/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface Carriers
 */
export interface Carriers {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof Carriers
     */
    marketingCarrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof Carriers
     */
    operatingCarrier?: GuidIdCodeAndLabel;
}

export function CarriersFromJSON(json: any): Carriers {
    return CarriersFromJSONTyped(json, false);
}

export function CarriersFromJSONTyped(json: any, ignoreDiscriminator: boolean): Carriers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'marketingCarrier': !exists(json, 'marketingCarrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['marketingCarrier']),
        'operatingCarrier': !exists(json, 'operatingCarrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['operatingCarrier']),
    };
}

export function CarriersToJSON(value?: Carriers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'marketingCarrier': GuidIdCodeAndLabelToJSON(value.marketingCarrier),
        'operatingCarrier': GuidIdCodeAndLabelToJSON(value.operatingCarrier),
    };
}


